import Input from 'atomic/form/input';
import classNames from 'classnames';
import FilterEntry from '../filter-entry';
import React, { ReactElement, useMemo, useState } from 'react';
import './filter-entry-search.scss';
import { FiltersEntry } from 'modules/shared/components/filters/interfaces/filters-entry.interface';
import { FiltersActions } from 'modules/producers/reducers/producer-url-params.reducer';
import { useProducerUrlType } from 'modules/producers/hooks/use-producer-url';
import { useCategoryUrlType } from 'modules/categories/interfaces/use-category-url.type';

let i = 0;

const SearchList: React.FC<{
    entries: FiltersEntry[];
    rel?: string;
    getUrl: useCategoryUrlType | useProducerUrlType;
    filtersActions: typeof FiltersActions;
}> = ({ entries, rel, getUrl, filtersActions }): ReactElement => {
    if (entries.length === 0) {
        return <div className="no-search-result">Brak wyników</div>;
    }

    return (
        <>
            {
                entries.map((entry) => (
                    <FilterEntry
                        key={entry.name}
                        id={entry.id}
                        name={entry.name}
                        count={entry.count}
                        position={entry.position}
                        description={entry.description}
                        checked={entry.checked}
                        rel={rel}
                        getUrl={getUrl}
                        filtersActions={filtersActions}
                    />
                ))
            }
        </>
    );
};

const FilterEntrySearch: React.FC<{
    entries: FiltersEntry[];
    rel?: string;
    getUrl: useCategoryUrlType | useProducerUrlType;
    filtersActions: typeof FiltersActions;
}> = ({ entries, rel, getUrl, filtersActions }): ReactElement => {
    const [pattern, setPattern] = useState<RegExp | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (event.target.value !== '') {
            setPattern(() => new RegExp(`\\b${event.target.value}`, 'i'));
        } else {
            setPattern(null);
        }
    };

    const entriesList = useMemo(() => {
        return pattern ? entries.filter(entry => pattern.test(entry.name)) : entries;
    }, [entries, pattern]);

    return (
        <div className={classNames({
            'filters-entries-search': true
        })}
        >
            {entries.length > 9 && (
                <Input
                    type="search"
                    name={(i++).toString()}
                    label="Szukaj"
                    small={true}
                    onChange={handleChange}
                    icon={{ name: 'search', title: '' }}
                    autoComplete="off"
                />
            )}
            <div className="filters-entries-content">
                <SearchList
                    entries={entriesList}
                    rel={rel}
                    getUrl={getUrl}
                    filtersActions={filtersActions}
                />
            </div>
        </div>
    );
};

export default FilterEntrySearch;
